import React from "react";
import io from "socket.io-client";
import Layout from "./components/layout/layout";
import { MpaIcon } from "./components/icon";

export class App extends React.Component {
  constructor() {
    super();
    this.state = {
      editing: false,
      port: 8001,
      endpoint: "http://" + window.location.hostname + ":" + 8001,
      data: {},
      ready: false
    };
  }

  socket;
  clientId;

  /* Initialize the socket and begin communication with the websocket server */
  initSocket = () => {
    this.socket = io(this.state.endpoint);
    this.socket.on("connect", () => {
      /* Once the connection with the socket is established, offer this application as a client to the server */
      this.init();

      /* Setup a disconnection handler in case the server goes away */
      this.socket.on("disconnect", reason => {
        console.log(`disconnected due to ${reason}`);

        /* If something failed, ensure to set ready to false so the configuation screen can be shown again */
        this.setState({ ready: false, data: {} });
      });
    });
  };

  exitSocket = () => {
    ["data", "client-ready", "disconnect", "connect"].forEach(s => {
      this.socket.off(s);
    });
    this.socket.close();
  };

  componentDidMount() {
    /* "Loose" entry point of the application */
    this.initSocket();
  }

  request = () => {
    /* Send out a notification to the server that a client is attempting to connect */
    this.socket.emit("client");
  };

  init = () => {
    this.request();

    /* If the server is ready to accept connections, it will send you messages back on client-ready */
    this.socket.on("client-ready", clientId => {
      this.clientId = clientId;

      /* Actual application data is communicated on the "data" topic. Here, the very first data being sent to the client is the client-id.*/
      this.socket.emit("data", this.clientId);
    });

    /* Set up a handler to receive data on the "data" topic */
    this.socket.on("data", data => {
      /* Once the initial handshake has been established, the "ready" state variable is set to true.
       * Whenever the state variable of the compnent changes, the render() will be called.
       * Look at the render() function for further applciation flow */

      /* The entire layout is server driven. The "data" received by the client here will drive the layout*/
      this.setState({ data, ready: true });
    });

    this.socket.on("brute-force-refresh", () => {
      window.location.reload(true);
    });
  };

  handleUpdatePort = () => {
    if (this.state.editing) {
      this.setState({ editing: false });
      this.setState(
        {
          port: this.state.port,
          endpoint: "http://" + window.location.hostname + ":" + this.state.port
        },
        () => {
          console.log(`updating port to ${this.state.port}`);
          this.exitSocket();
          this.initSocket();
        }
      );
    } else {
      this.setState({ editing: true });
    }
  };

  handleUpdatePortTextChange = evt => {
    this.setState({ port: evt.target.value });
  };

  render() {
    /* The handshake has been completed. Show the Layout component */
    if (this.state.ready) {
      /* Pass down the socket object and data received from the server to deeper components so that
       * they can reuse the existing socket connection. */
      return (
        <Layout
          data={this.state.data}
          socket={this.socket}
          clientId={this.clientId}
        ></Layout>
      );
    } else {
      /* Until the handshake is incomplete, show the screen for the user to configure the port */
      return (
        <React.Fragment>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <MpaIcon style={{ fontSize: 100 }}></MpaIcon>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <h1>Waiting For Your Tiles Hub To Come Online</h1>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <h2>Address: {window.location.hostname}</h2>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <h2>Port:</h2>
            <input
              onChange={this.handleUpdatePortTextChange}
              value={this.state.port}
              type="text"
              style={{
                marginLeft: "10px",
                marginRight: "10px",
                backgroundColor: "transparent",
                border: "1px solid white",
                color: "white",
                fontSize: "1.5em ",
                fontWeight: "bold",
                maxWidth: "100px",
                textAlign: "center",
                borderRadius: "10px"
              }}
              disabled={this.state.editing ? false : true}
            ></input>
            <button
              style={{
                marginLeft: "20px",
                backgroundColor: "transparent",
                border: "1px solid white",
                color: "white",
                fontSize: "1.5em ",
                fontWeight: "bold",
                maxWidth: "100px",
                borderRadius: "10px"
              }}
              onClick={this.handleUpdatePort}
            >
              {this.state.editing ? "DONE" : "EDIT"}
            </button>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default App;
